/* ============================================================
 * Casa M Spice Co — short-form clip player (tap-to-play)
 * Added 2026-06-19.
 *
 * Progressive enhancement for the [data-clip] stages rendered by
 * snippets/clip-player.liquid. Until the user taps, the stage holds only
 * a poster <img> + an inert <template> — no <video>/<iframe> is in the DOM,
 * so nothing streams and the page's CWV budget is untouched. On tap we clone
 * the template into the stage and (for native video) start playback.
 *
 * If JS is off the poster still shows; the clip's dedicated watch page
 * (linked from each rail card) remains the full-fidelity fallback.
 * ============================================================ */
(function () {
  'use strict';

  function activate(stage) {
    if (!stage || stage.dataset.clipActive) return;
    var tpl = stage.querySelector('.d2-clip__player');
    if (!tpl || !tpl.content) return;

    stage.dataset.clipActive = '1';
    var poster = stage.querySelector('.d2-clip__poster');
    var frag = tpl.content.cloneNode(true);
    if (tpl.remove) tpl.remove();
    if (poster) poster.remove();
    stage.appendChild(frag);

    var video = stage.querySelector('video');
    if (video && typeof video.play === 'function') {
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.d2-clip__poster');
    if (!btn) return;
    var stage = btn.closest('[data-clip]');
    if (!stage) return;
    e.preventDefault();
    activate(stage);
  });
})();
